import Contact from "../sections/Contact";
import Hero from "../sections/Hero.jsx";
import Reference from "../sections/References";
import SwissReferences from "../sections/SwissReferences";
import AboutUs from "../sections/AboutUs";
import EngagementPartner from "../sections/EngagementPartner";

import Footer from "../components/Footer";

const Landing = () => {
	return (
		<>
			<Hero />
			<AboutUs />
			<SwissReferences />
			<Reference />
			<EngagementPartner />
			<Contact />
			<Footer />
		</>
	);
};

export default Landing;
